import { InitContactDialogInput } from 'api-new/generated';
import { createContext, useContext } from 'react';

export type NewContactIframeModalContextType = {
  contactId: number;
};

export type NewContactIframeModalContextProps = {
  openContactIframe?: (contactIframeType: NewContactIframeModalContextType) => void;
  openConfirmDialogModal?: (contact: InitContactDialogInput) => void;
};

export const NewContactIframeModalContext = createContext<NewContactIframeModalContextProps>({});

export const useNewContactIframeModalContext = () => useContext(NewContactIframeModalContext);
